class ConfigService {
    getJson(url, callback) {
        const Xhr = new XMLHttpRequest();

        Xhr.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                try {
                    callback(JSON.parse(this.responseText));
                } catch (err) {}
            }
        };

        Xhr.open("GET", url, true);
        Xhr.send();
    }

    getCoBadgedCards(callback) {
        this.getJson('Templates/imagesPaymentPageDropDown_v1_PaymentPage/data/coBadgedCards.json', json => callback(json));
    }

    getTranslations(callback) {
        this.getJson('Templates/imagesPaymentPageDropDown_v1_PaymentPage/data/translations.json', json => callback(json));
    }
}

export default new ConfigService();



// WEBPACK FOOTER //
// ./src/services/configService.js